import { CommonModule } from '@angular/common';
import { Component, computed, effect, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EditorModule } from 'primeng/editor';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { BinderAssembly } from 'src/app/models/binder-assembly.model';
import { BinderAssembliesService } from 'src/app/services/app/binder-assemblies.service';
import { UserAccessService } from 'src/app/services/app/user-access.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { ClipboardService } from '@/services/app/clipboard.service';
import { AppStateService } from '@/services/app/app-state.service';
import { RichTextEditorComponent } from '@/global/rich-text-editor.component';

@Component({
    selector: 'app-landmark-assembly-group',
    imports: [
        CommonModule,
        ButtonModule,
        AccordionModule,
        SkeletonModule,
        TableModule,
        EditorModule,
        InputTextModule,
        InputNumberModule,
        InputTextModule,
        ToggleSwitchModule,
        ConfirmDialogModule,
        FormsModule,
        RichTextEditorComponent
    ],
    templateUrl: './assembly-group.component.html',
    styleUrls: ['./assembly-group.component.scss'],
    standalone: true
})
export class LandmarkAssemblyGroupComponent {
  @Input() assemblies: BinderAssembly[] = [];
  clonedAssemblies: { [s: string]: BinderAssembly } = {};
  learningMode: boolean = false;

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private binderDialogService: BinderDialogService,
    private appStateService: AppStateService,
    private binderAssemblyService: BinderAssembliesService,
    public userAccessService: UserAccessService,
    private clipboardService: ClipboardService
    ) { 
      effect(() => {
        this.learningMode = this.appStateService.learningMode();
      });
    }

get categoryId() {
  return this.assemblies.filter(assembly => assembly.CategoryID !== 0)[0]?.CategoryID || 0;
}


  showEngineering() {
    this.binderDialogService.toggleDialog('Engineering', 'engineering', true);
  }

  copyAssembly(assembly: BinderAssembly) {
    this.clipboardService.copyData(assembly);
  }

  onRowEditInit(assembly: BinderAssembly) {
    console.log(assembly)
    this.clonedAssemblies[assembly.BAID.toString() as string] = { ...assembly };
  }

  onRowEditSave(assembly: BinderAssembly) {
    if(!this.learningMode){
    this.binderAssemblyService.updateAssembly(assembly.BAID,assembly).subscribe({
      next: (updated) => {
        console.log('assembly updated', updated);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact updated successfully' });
      },
      error: (error) => {
        console.error('Error updating assembly:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update Contact:' + error });
      }
    });
  }
  else {
    this.binderAssemblyService.updateAssemblyLocally(assembly.BAID,assembly);
  }
    
  }

  showButtonCell(categoryId: number):boolean {
    if(this.userAccessService.foundersRestrictedAccess()) {
      return this.userAccessService.foundersCategoryIds.includes(categoryId);
    }
    return true;
  }

  checkAccess(assembly: BinderAssembly, deleteOnly: boolean = false) {
    const hasEditAccess = this.userAccessService.binderEditAccess() && this.userAccessService.binderAssembliesEditAccess();
    const foundersRestrictAccess = this.userAccessService.foundersRestrictedAccess();

    if(assembly.Type === 'F' && deleteOnly) {
      return false;
    }
  
    if (!hasEditAccess) {
      return false;
    }
  
    if (foundersRestrictAccess) {
      return this.userAccessService.foundersCategoryIds.includes(assembly.CategoryID);
    }
  
    return true;
  }

  onRowEditCancel(assembly: BinderAssembly, index: number) {
    this.assemblies[index] = this.clonedAssemblies[assembly.BAID.toString() as string];
    delete this.clonedAssemblies[assembly.BAID.toString() as string];
  }

  removeAssembly(assembly: BinderAssembly) {
    if(!this.learningMode){
    this.binderAssemblyService.removeAssembly(assembly.BAID).subscribe({
      next: (deleted) => {
        console.log('assembly deleted', deleted);
      },
      error: (error) => {
        console.error('Error removing assembly:', error);
      }
    });
  }
  else {
    this.binderAssemblyService.removeAssemblyLocally(assembly.BAID);
  }
}

  confirmDeleteAssembly(assembly: BinderAssembly) {
    this.confirmationService.confirm({
        header: "Confirm Delete",
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        acceptLabel: 'Delete',
        rejectLabel: 'Cancel',
        message: "Are you sure you want to delete this assembly?",
        accept: () => {
            this.removeAssembly(assembly);
        },
        reject: () => {
            
        }
    });
}

}
